<template>
  <ExamAnalysis :path="'/continueEdu'" style="margin-top: -86px;"></ExamAnalysis>
</template>

<script>
  import ExamAnalysis from '@/page/modules/exam/analysis'
  export default {
    components: { ExamAnalysis },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/exam/analysis.vue